import React from 'react';
import styled from 'styled-components';
import { ImageWithTextCard } from '@/components/organisms';
import { IImageWithTextDataCmp } from '../IImageWithTextCmp';
const Container = styled.div<IContainer>`
  text-align: center;
  margin: 0 auto;
  display: grid;
  grid-template-columns: ${props =>
    props.template === 'category_card' ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)'};
  justify-content: center;
  justify-items: center;
  align-items: start;
  width: 100%;
  ${props => props.theme.breakpoints.up('sm')} {
    grid-template-columns: repeat(${props => props.repeat}, 1fr);
    gap: 24px;
  }
  ${props => props.theme.breakpoints.up('md')} {
    gap: 32px;
  }
  ${props => props.theme.breakpoints.up('lg')} {
    padding: 0;
  }
`;

interface IContainer {
  repeat: number;
  template: string;
}

const ImageWithTextCategoryList: React.FC<IImageWithTextDataCmp> = props => {
  const { imageWithTextData, template } = props;

  let listOfImageWithText = imageWithTextData.map(singleElement => {
    if (singleElement) {
      return (
        <ImageWithTextCard
          key={singleElement.id}
          {...singleElement}></ImageWithTextCard>
      );
    }
  });

  let repeat = imageWithTextData.length <= 4 ? imageWithTextData.length : 3;

  if (listOfImageWithText.length > 0) {
    return (
      <>
        <Container repeat={repeat} template={template}>
          {listOfImageWithText}
        </Container>
      </>
    );
  } else return null;
};

export default ImageWithTextCategoryList;
